import { render, staticRenderFns } from "./dataV_C.vue?vue&type=template&id=1c9ba5f8&scoped=true&"
import script from "./dataV_C.vue?vue&type=script&lang=js&"
export * from "./dataV_C.vue?vue&type=script&lang=js&"
import style0 from "./dataV_C.vue?vue&type=style&index=0&id=1c9ba5f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9ba5f8",
  null
  
)

export default component.exports